import BaseModel from './BaseModel';

export default class AuthorisationRequestRequesteeModel extends BaseModel {
  fullName: string;
}
